import { render } from "./MiscDemo.vue?vue&type=template&id=d0a54c14&scoped=true"
import script from "./MiscDemo.vue?vue&type=script&lang=js"
export * from "./MiscDemo.vue?vue&type=script&lang=js"

import "./MiscDemo.vue?vue&type=style&index=0&id=d0a54c14&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0a54c14"]])

export default __exports__